import React from 'react';
import css from '@emotion/css';
import styled from '@emotion/styled';

interface IShadowCircle {
  step: number;
}

interface ICountOverlay extends IShadowCircle {
  count: string;
}

const CountOverlay: React.FC<ICountOverlay> = ({ step = 0, count = 3 }) => {
  return (
    <OverlayWrapper>
      <OverlayContainer>
        <Background />
        <ContentWrapper>
          <CircleWrapper>
            <ShadowCircle step={step}>
              <SolidCircle  step={step}>
                <CountNumber step={step}>{count}</CountNumber>
              </SolidCircle>
            </ShadowCircle>
          </CircleWrapper>
        </ContentWrapper>
      </OverlayContainer>
    </OverlayWrapper>
  );
};

export default CountOverlay;


const fixedStyle = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;


const absoluteStyle = css`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const flexStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const OverlayWrapper = styled.div`
  ${fixedStyle}
  pointer-events: none;

  * {
    pointer-events: none;
  }
`;

const OverlayContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`;

const Background = styled.div`
  ${absoluteStyle}
  opacity: 0.83;
  background-color: white;

  html[color-mode='dark'] & {
    background-color: #111316;
  }
`;

const ContentWrapper = styled.div`
  ${absoluteStyle}
  ${flexStyle}
`;

const CircleWrapper = styled.div`
  ${flexStyle}
  width: 168px;
  height: 168px;
`;

const ShadowCircle = styled.div<IShadowCircle>`
  ${flexStyle}
  width: 120px;
  height: 120px;
  border-radius: 81px;
  background: rgba(10, 132, 255, 0.5);
  transition: transform 0.5s ease-in-out;
  transform: scale(1);
  ${({ step }) =>
    step &&
    css`
      // width: 168px;
      // height: 168px;
      transform: scale(1.5);
    `};
`;

const SolidCircle = styled.div<IShadowCircle>`
  ${flexStyle}
  width: 120px;
  height: 120px;
  border-radius: 81px;
  background-color: #0a84ff;
  transition: transform 0.5s ease-in-out;
  
  ${({ step }) =>
    step &&
    css`
      transform: scale(0.67);
  `};
`;

const CountNumber = styled.span<IShadowCircle>`
  font-size: 48px;
  font-weight: bold;
  color: white;
  transition: opacity 0.25s ease-in-out;

  ${({ step }) => css`
    opacity: ${step ? (step === 1 ? 0.5 : 1) : 0.5};
  `};
`;
